// import { Button, Dialog, Input } from '@platform/design-system';
// import { useAuth } from '@platform/auth-client';
import { useTranslation } from '@platform/i18n';
// import { ChevronsUpDown } from 'lucide-react';
// import { useState } from 'react';
import styles from './Shell.module.css';

export type TenantSwitcherVariant = 'card' | 'compact';

export type ShopIdentity = { readonly name: string; readonly detail: string | null };

export type TenantSwitcherProps = { variant: TenantSwitcherVariant; shop: ShopIdentity };

export const TenantSwitcher = ({ variant, shop }: TenantSwitcherProps) => {
  const { t } = useTranslation();
  // const auth = useAuth();
  // const [open, setOpen] = useState(false);
  // const [slug, setSlug] = useState('');
  return (
    <>
      {/* <button
        type="button"
        className={styles['tenant']}
        data-variant={variant}
        onClick={() => {
          setOpen(true);
        }}
        aria-label={t('shell.switchTenant')}
      > */}
      <div className={styles['tenant']} data-variant={variant} data-static="true">
        <span className={styles['tenantMark']} aria-hidden="true">
          {shop.name.charAt(0).toUpperCase()}
        </span>
        <span className={styles['tenantText']}>
          <span className={styles['tenantName']}>{shop.name}</span>
          <span className={styles['tenantHint']}>{shop.detail ?? t('shell.switchTenant')}</span>
        </span>
        {/* <ChevronsUpDown size={16} aria-hidden="true" className={styles['tenantChevron']} /> */}
      </div>
      {/* </button>
      <Dialog
        open={open}
        title={t('shell.switchTenant')}
        onClose={() => {
          setOpen(false);
        }}
        footer={
          <Button
            disabled={slug.trim().length === 0}
            onClick={() => {
              void auth.switchTenant(slug.trim());
            }}
          >
            {t('shell.switchTenantConfirm')}
          </Button>
        }
      >
        <Input
          label={t('shell.tenant')}
          value={slug}
          onChange={(event) => {
            setSlug(event.target.value);
          }}
          autoComplete="off"
        />
      </Dialog> */}
    </>
  );
};
